<template>
  <e-scrollable-search-filter-page :service="pageService"
                                   ref="page"
                                   v-on:enableSpinner="enableSpinner()"
                                   v-on:disableSpinner="disableSpinner()">

    <!-- MYEM-197: customer filter for admins and branch admins -->
    <template v-slot:header-filter>
      <div v-if="isAdmin" class="customer-select">
        <v-select id="template-customer-select"
                  :options="customers"
                  :reduce="customer => customer.customerId"
                  :get-option-label="customerLabel"
                  :placeholder="$t('template.customer.select')"
                  :value="customerId"
                  @input="selectCustomer($event)" />
      </div>
    </template>

    <template v-slot:header-controls="{ created, links }">
      <b-button-toolbar key-nav class="float-right">

        <b-button-group class="mx-1" v-if="links?.create?.href">
          <b-button type="button"
                    size="sm"
                    variant="secondary"
                    class="pl-2 pr-2"
                    @click="created(service.create())">
            <b-icon icon="plus"/>
            {{ $t('controls.create') }}
          </b-button>
        </b-button-group>

      </b-button-toolbar>
    </template>

    <template v-slot:spinner>

      <b-spinner v-if="loading"
                 class="spinner"
                 label="Loading..."/>

      <div v-else-if="hint" id="template-hint" class="hint text-muted">
        {{ $t(hint) }}
      </div>

    </template>

    <template v-slot:entity-content="{ id, entity, index, deleted, saved }">
      <detail-view :id="id"
                   :value="entity"
                   @delete="deleted(index)"
                   @save="saved(index, $event)"
                   v-on:enableSpinner="enableSpinner()"
                   v-on:disableSpinner="disableSpinner()"/>
    </template>

  </e-scrollable-search-filter-page>
</template>

<script>
import service from "@/services/cargoListTemplate.service";
import DetailView from "@/components/CargoListTemplateView";
import {log} from "@emons/emons-vue"

const ADMIN_ROLES = ['EIP_MyEmons_Admin', 'EIP_MyEmons_All_NL_Admin', 'EIP_MyEmons_NL_Admin']

export default {
  name: 'CargoTemplateList',
  components: {DetailView},
  data() {
    const keycloak = this.$root.$options.keycloak
    const isAdmin = ADMIN_ROLES.some(role => keycloak?.hasRealmRole?.(role))
    return {
      loading: false,
      service: service,
      isAdmin: isAdmin,
      customers: [],
      customerId: null,
      searchText: null,
      resultCount: null,
      pageService: isAdmin ? this.createAdminService() : service
    }
  },
  computed: {
    hint: function () {
      if (!this.isAdmin) {
        return null
      }
      if (!this.customerId && !this.searchText) {
        return 'template.customer.select-or-search'
      }
      if (this.resultCount === 0) {
        return this.searchText ? 'template.search.no-results' : 'template.customer.no-templates'
      }
      return null
    }
  },
  created() {
    if (this.isAdmin) {
      this.findCustomers()
    }
  },
  methods: {
    enableSpinner: function () {
      log('debug', 'enableSpinner() called...')
      this.loading = true
    },
    disableSpinner: function () {
      log('debug', 'disableSpinner() called...')
      this.loading = false
    },
    createEntity: function () {
      this.$log('DEBUG', 'createEntity() called...')
      return this.service.create()
    },
    createAdminService: function () {
      const vm = this
      return Object.freeze({
        ...service,
        getHeader: () => service.getAdminHeader(),
        find: async (query, filters, projection, sortProperty, sortDirection, size, sync) => {
          vm.searchText = query || null
          if (!vm.customerId && !vm.searchText) {
            vm.resultCount = null
            return {data: {links: {}, page: {}, items: []}}
          }
          const response = await service.find(query, filters, projection, sortProperty, sortDirection, size, sync, vm.customerId)
          vm.resultCount = response?.data?.items?.length ?? 0
          return response
        }
      })
    },
    findCustomers: async function () {
      const response = await service.findCustomers()
      this.customers = response?.data || []
    },
    customerLabel: function (customer) {
      return customer?.name ? customer.customerId + ' - ' + customer.name : customer?.customerId
    },
    selectCustomer: function (customerId) {
      this.customerId = customerId || null
      this.$refs.page.find()
    }
  }
}
</script>

<style scoped>

.spinner {
  position: absolute;
  z-index: 100000;
  top: 25%;
  left: 50%;
}

.hint {
  position: absolute;
  z-index: 1;
  pointer-events: none;
  top: 25%;
  left: 0;
  right: 0;
  text-align: center;
}

.customer-select {
  font-size: 0.875rem;
}

</style>
